import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFinanceiroContasRecebidas } from '@/features/relatorio/page/financeiro/contas-recebidas/RelatorioFinanceiroContasRecebidas';

export const Route = createFileRoute('/a/relatorio/financeiro/contas-recebidas')({
    component: RelatorioFinanceiroContasRecebidas,
});
